import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", delay = 0, as = "h1" }) => {
  const Tag = motion[as] || motion.h1;
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span
            className="block will-change-transform"
            initial={{ y: "115%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.95, delay: delay + i * 0.13, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Marquee = ({ items, dark = false }) => {
  const row = [...items, ...items];
  return (
    <div
      data-testid="marquee-band"
      className={`relative overflow-hidden py-4 border-y ${
        dark ? "bg-brand-deep border-white/10 text-white/70" : "bg-gold border-gold text-brand-deep"
      }`}
    >
      <div className="flex w-max animate-marquee gap-0 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center font-mono text-xs font-bold uppercase tracking-[0.25em]">
            <span className="px-6">{item}</span>
            <span className={dark ? "text-gold" : "text-crimson"}>✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
